import { asMenuItem, MenuItem } from "../../components/menu";

const ICON = { ios: "f7:bell_fill", md: "material:notifications" };

const NotificationsButton = asMenuItem(({ onClick }) => (
  <MenuItem
    className="notifications-entry"
    title="Benachrichtigungen"
    icon={ICON}
    tone="red"
    onClick={onClick}
  />
));

export default NotificationsButton;
